(() => {
  if (window.__wbEmbLimitV3) return;
  window.__wbEmbLimitV3 = true;

  const MAX_OK = 12;
  const MAX_TMP = 13;
  const HELP_URL = 'https://shop.kawabe.co.jp/pages/about_emb';
  const TARGET_SELECTOR =
    'input[type="text"][name^="properties[刺繍テキスト："], input[type="text"][name-disabled^="properties[刺繍テキスト："]';

  let suppressBlurUntil = 0;
  const now = () => (Date.now ? Date.now() : +new Date());

  function getTargets(root) {
    return (root || document).querySelectorAll(TARGET_SELECTOR);
  }

  function ensureAlert(input) {
    const holder = input.closest('span') || input.parentElement || input;
    const existing = holder.querySelector('.wb-emb-alert');
    if (existing) return existing;

    const box = document.createElement('div');
    box.className = 'wb-emb-alert';
    box.style.display = 'none';

    const head = document.createElement('div');
    head.className = 'wb-emb-alert__head';
    head.innerHTML = '<strong>刺しゅうの文字数が12文字を超えています。</strong>';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'wb-emb-alert__close';
    close.setAttribute('aria-label', 'close');
    close.textContent = '×';

    const body = document.createElement('div');
    body.className = 'wb-emb-alert__body';
    body.innerHTML =
      '可能な文字数は最大12文字となります。<br>' +
      '刺繍について　詳しくは' +
      '<a class="wb-emb-alert__link" href="' +
      HELP_URL +
      '">こちら</a>';

    const suppressBlur = () => {
      suppressBlurUntil = now() + 800;
    };
    box.addEventListener('pointerdown', suppressBlur, true);
    box.addEventListener('mousedown', suppressBlur, true);
    box.addEventListener('touchstart', suppressBlur, true);

    box.appendChild(head);
    head.appendChild(close);
    box.appendChild(body);
    holder.appendChild(box);

    return box;
  }

  function show(box) {
    box.style.display = 'block';
  }

  function hide(box) {
    box.style.display = 'none';
  }

  function bind(input) {
    if (!input || input.dataset.wbEmbBound === '1') return;
    input.dataset.wbEmbBound = '1';

    try {
      input.removeAttribute('maxlength');
    } catch (e) {}

    const box = ensureAlert(input);
    const closeBtn = box.querySelector('.wb-emb-alert__close');
    let isComposing = false;

    function clampToTmpMax() {
      const v = input.value || '';
      if (v.length > MAX_TMP) input.value = v.slice(0, MAX_TMP);
    }

    function clampToFinalMax() {
      const v = input.value || '';
      if (v.length > MAX_OK) input.value = v.slice(0, MAX_OK);
    }

    function shouldShowAlert() {
      return (input.value || '').length > MAX_OK;
    }

    function updateAlertDeferred() {
      setTimeout(() => {
        if (shouldShowAlert()) show(box);
        else hide(box);
      }, 0);
    }

    if (closeBtn && !closeBtn.dataset.wbEmbCloseBound) {
      closeBtn.dataset.wbEmbCloseBound = '1';
      closeBtn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          clampToFinalMax();
          hide(box);
          try {
            input.focus();
          } catch (_) {}
        },
        true
      );
      closeBtn.addEventListener(
        'pointerdown',
        () => {
          suppressBlurUntil = now() + 800;
        },
        true
      );
    }

    input.addEventListener('compositionstart', () => {
      isComposing = true;
    });

    input.addEventListener('compositionend', () => {
      isComposing = false;
      clampToTmpMax();
      updateAlertDeferred();
    });

    input.addEventListener('input', () => {
      if (isComposing) return;
      clampToTmpMax();
      updateAlertDeferred();
    });

    input.addEventListener(
      'keydown',
      (e) => {
        if (e.key !== 'Enter') return;
        if (isComposing) return;
        e.preventDefault();
        e.stopPropagation();
        clampToTmpMax();
        updateAlertDeferred();
        input.blur();
      },
      true
    );

    input.addEventListener(
      'blur',
      () => {
        if (now() < suppressBlurUntil) return;
        isComposing = false;
        clampToFinalMax();
        hide(box);
      },
      true
    );
  }

  function apply(root) {
    if (root && root.nodeType === 1 && root.matches && root.matches(TARGET_SELECTOR)) {
      bind(root);
    }
    getTargets(root).forEach(bind);
  }

  apply(document);

  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.type === 'attributes' && m.target && m.target.nodeType === 1) {
        apply(m.target);
        return;
      }
      (m.addedNodes || []).forEach((node) => {
        if (node && node.nodeType === 1) apply(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['name', 'name-disabled'],
  });
})();
